// Shared landscape-rotation guard for the cooking surfaces. The cook screen
// and the Preview walkthrough both force landscape on phones (a rotation
// prompt rather than a CSS lock — README §6.7).

import { useEffect, useState } from 'react';

const ROTATION_QUERY = '(orientation: portrait) and (max-width: 768px)';

export function useShouldPromptRotation(): boolean {
  const [portrait, setPortrait] = useState<boolean>(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(ROTATION_QUERY).matches;
  });
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(ROTATION_QUERY);
    const onChange = (e: MediaQueryListEvent): void => setPortrait(e.matches);
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    // Older browsers — back to the deprecated MQL `onchange`.
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, []);
  return portrait;
}
